import React, { useState, useEffect } from "react";
import "../../programs.css";
import { useNavigate } from "react-router-dom";

const tabs = [
  "Popular",
  "Computer Science",
  "Mechanical & Civil",
  "Electrical & Electronics",
  "Management",
  "Bio-Technology",
];

const programsByTab = {
  Popular: [
    {
      title: "Artificial Intelligence",
      description:
        "Where machines learn to think, and you learn to shape the future.",
      bgClass: "bg-ain",
      route: "/artificial-intelligence",
    },
    {
      title: "Data Science",
      description:
        "The science of finding stories hidden inside data.",
      bgClass: "bg-ds",
      route: "/data-science",
    },
    {
      title: "Digital Marketing",
      description:
        "Building brand success in a world powered by screens.",
      bgClass: "bg-dm",
      route: "/digital-marketing",
    },
    {
      title: "Drone Engineering",
      description:
        "Designing intelligent machines that take innovation to the skies.",
      bgClass: "bg-webdev",
      route: "/drone-engineering",
    },
    {
      title: "Web Development",
      description:
        "Where imagination takes shape in pixels and code.",
      bgClass: "bg-webdev",
      route: "/web-development",
    },
  ],
  "Computer Science": [
    {
      title: "Android App Development",
      description:
        "Build mobile apps that solve real-world problems and power digital experiences.",
      bgClass: "bg-AAD",
      route: "/android-app-development",
      btnColor: "#007bff",
    },
    {
      title: "Artificial Intelligence",
      description:
        "Explore the world of intelligent systems and real-world applications across industries.",
      bgClass: "bg-ain",
      route: "/artificial-intelligence",
    },
    {
      title: "AR/VR",
      description:
        "Blending realities to turn imagination into experience.",
      bgClass: "bg-arvr",
      route: "/ar-vr",
    },
    {
      title: "Cloud Computing",
      description:
        "Powering a world where data moves faster than ideas.",
      bgClass: "bg-cc",
      route: "/cloud-computing",
    },
    {
      title: "Cyber Security",
      description:
        "Guarding the digital world where threats evolve faster than time.",
      bgClass: "bg-cs",
      route: "/cyber-security",
    },
    {
      title: "Data Analytics",
      description:
        "Decoding patterns that predict the future with precision.",
      bgClass: "bg-da",
      route: "/data-analytics",
    },
    {
      title: "Data Science",
      description:
        "The science of finding stories hidden inside data.",
      bgClass: "bg-ds",
      route: "/data-science",
    },
    {
      title: "DSA ",
      description:
        "The backbone of efficient code and the language of powerful systems.",
      bgClass: "bg-dsa",
      route: "/dsa",
    },
    {
      title: "Generative AI",
      description:
        "Where machines imagine, create, and push innovation beyond human limits.",
      bgClass: "bg-gai",
      route: "/generative-ai",
    },
    {
      title: "Graphic Design",
      description:
        "Crafting visuals that speak louder than words in a world led by creativity.",
      bgClass: "bg-gd",
      route: "/graphic-design",
    },
    {
      title: "Java-Full Stack",
      description:
        "Building powerful, end-to-end applications that run the modern digital world.",
      bgClass: "bg-jfs",
      route: "/java-full-stack",
    },
    {
      title: "Machine Learning ",
      description:
        "Teaching systems to learn, predict, and make smarter decisions.",
      bgClass: "bg-ml",
      route: "/machine-learning",
    },
    {
      title: "MERN Stack",
      description:
        "Code the future with a stack built for speed, scalability, and innovation.",
      bgClass: "bg-mern",
      route: "/mern-stack",
    },
    {
      title: "Robtics",
      description:
        "Where mechanics meets AI to build the next generation of smart automation.",
      bgClass: "bg-rb",
      route: "/robotics",
    },
    {
      title: "UI/UX",
      description:
        "The art of blending visuals and psychology to create powerful user experiences.",
      bgClass: "bg-uiux",
      route: "/ui-ux",
    },

    {
      title: "Web Development",
      description:
        "Where imagination takes shape in pixels and code.",
      bgClass: "bg-webdev",
      route: "/web-development",
    },
  ],
  "Mechanical & Civil": [
    {
      title: "AutoCAD",
      description:
        "Turning precise drawings into real-world structures with technical accuracy.",
      bgClass: "bg-ac",
      route: "/autocad",
    },
    {
      title: "Car Design",
      description:
        "Shaping machines that move emotions before they move wheels.",
      bgClass: "bg-ds",
      route: "/car-design",
    },
    {
      title: "Drone Engineering",
      description:
        "Driving the future with dual-energy innovation and sustainable performance.",
      bgClass: "bg-webdev",
      route: "/drone-engineering",
    },
    {
      title: "HEV",
      description:
        "Master CAD tools essential for precision design in engineering and architecture.",
      bgClass: "bg-hev",
      route: "/hybrid-electric-vehicle",
    },
    {
      title: "IC Engine",
      description:
        "The heart of mobility—engineered for efficiency, strength, and reliability.",
      bgClass: "bg-ice",
      route: "/ic-engine",
    },
  ],
  "Electrical & Electronics": [
    {
      title: "Embedded Systems",
      description:
        "Crafting micro-brains that control everything from cars to satellites.",
      bgClass: "bg-es",
      route: "/embedded-systems",
    },
    {
      title: "IoT ",
      description:
        "Turning the physical world into a network of intelligent systems.",
      bgClass: "bg-ml",
      route: "/internet-of-things",
    },
    {
      title: "VLSI",
      description:
        "Compressing millions of transistors into microchips that power the modern world.",
      bgClass: "bg-webdev",
      route: "/vlsi",
    },
  ],
  Management: [
    {
      title: "Business Analytics",
      description:
        "Turning complex data into smart strategies that drive real growth.",
      bgClass: "bg-ba",
      route: "/business-analytics",
    },
    {
      title: "Digital Marketing",
      description:
        "Building brand success in a world powered by screens.",
      bgClass: "bg-dm",
      route: "/digital-marketing",
    },
    {
      title: "Finance",
      description:
        "Mastering the flow of money to fuel growth, stability, and opportunity.",
      bgClass: "bg-fs",
      route: "/finance",
    },
    {
      title: "Human Resources",
      description:
        "Empowering people, shaping culture, and unlocking organizational potential.",
      bgClass: "bg-hr",
      route: "/human-resource",
    },
    {
      title: "Stock Marketing",
      description:
        "From candlesticks to capital—learn the skill that builds wealth.",
      bgClass: "bg-sm",
      route: "/stock-market",
    },
    {
      title: "Supply Chain Management",
      description:
        "Mastering the journey from raw material to satisfied customer.",
      bgClass: "bg-scm",
      route: "/supply-chain-management",
    },
  ],
  "Bio-Technology": [
    {
      title: "Bioinformatics",
      description:
        "Where biology meets computation to unlock the secrets of living systems.",
      bgClass: "bg-b",
      route: "/bio-informatics",
    },

    {
      title: "Genetic Engineering",
      description:
        "Rewriting DNA to shape healthier futures and smarter organisms.",
      bgClass: "bg-webdev",
      route: "/genetic-engineering",
    },
    {
      title: "Nanoscience & Nanotechnology",
      description:
        "Engineering the invisible to transform medicine, energy, and materials.",
      bgClass: "bg-ml",
      route: "/nanoscience-nanotechnology",
    },
    {
      title: "Psychology",
      description:
        "Decoding why we think, feel, and act the way we do.",
      bgClass: "bg-psy",
      route: "/psychology",
    },

    {
      title: "Regulatory Affairs (in Pharma & Healthcare)",
      description:
        "Ensuring medicines and medical innovations are safe, compliant, and globally trusted.",
      bgClass: "bg-ra",
      route: "/regulatory-affairs",
    },
  ],
};

export default function ProgramsPage() {
  const navigate = useNavigate();
  const [selectedTab, setSelectedTab] = useState("Popular");
  const programs = programsByTab[selectedTab];

  const [animate, setAnimate] = useState(false);
  const [initialRender, setInitialRender] = useState(true);
  useEffect(() => {
    setAnimate(false);

    const timeout = setTimeout(() => {
      setAnimate(true);
      setInitialRender(false);
    }, 40);

    return () => clearTimeout(timeout);
  }, [selectedTab]);

  return (
    <div className="programs-main">
      <h1 className="programs-title">The Learning Journey You Will Remember</h1>
      <div className="programs-tabs">
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`tab ${selectedTab === tab ? "selected" : ""}`}
            onClick={() => setSelectedTab(tab)}
          >
            {tab}
          </div>
        ))}
      </div>

      <div className="programs-list">
        {programs.map((program, index) => (
          <div
            key={program.title}
            className={`program-card ${
              animate ? "program-animate" : "pre-hidden"
            }`}
            // className={`program-card ${animate ? "program-animate" : "pre-hidden"} ${program.bgClass}`}
            style={{ animationDelay: `${index * 0.2}s` }}
            onClick={() => navigate(program.route)}
          >
            <div className={`program-card-top ${program.bgClass}`}>
              <div className="program-card-title">{program.title}</div>
            </div>
            <div className="program-card-title-heading">{program.title}</div>
            <div className="program-card-desc">{program.description}</div>
            <button className="program-card-btn">View Program</button>
          </div>
        ))}
      </div>
    </div>
  );
}
